<template>
  <div>
    <section
      v-if="allowedAccess"
      class="content box-management"
    >
      <div class="row">
        <div class="col-sm-12">
          <div class="box box-default box-solid">
            <div class="box-body">
              <form>
                <div class="row">
                  <select-type
                    class="col-sm-4 col-md-3"
                    name="role"
                    :label="'Rola'"
                    :required="false"
                    :options="roles"
                    :disabled="!rolesLoaded"
                    :empty-first="true"
                    :value="model.roleId"
                    @input="changeRole"
                  />
                </div>
                <div
                  v-if="model.roleId !== null"
                  class="row"
                >
                  <div class="col-sm-12">
                    <h2>Wymagalność kategorii załączników</h2>
                    <list
                      :items="model.categoryRequirements"
                      :empty-element="createEmptyElement()"
                      @modified="forceToSave"
                    >
                      <template
                        slot="element"
                        slot-scope="listItems"
                      >
                        <attachment-requirement-type
                          v-model="listItems.item"
                          :task-categories="taskCategories"
                          :states="states"
                          :categories="categories"
                          @modified="forceToSave"
                        />
                      </template>
                    </list>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <save-data-information
      :show="saveDataInformationVisible"
      @close="saveDataInformationVisible = false"
    />

    <login-modal
      :show="loginVisible"
      :back-url-name="`${service}_appraisal_attachment_category_requirement_listing`"
      @close="loginVisible = false"
      @success="init()"
    />
  </div>
</template>

<script>
import Page from '../../../../../share/content/Page'
import api from '../../../../../../api'
import ErrorNotify from '../../../../../share/mixins/ErrorNotify'
import List from '../../../../../share/form/List'
import SelectType from '../../../../../share/form/type/SelectType'
import LoginModal from '../../../../share/modal/LoginModal'
import AttachmentRequirementType from '../../../share/form/type/AttachmentRequirementType'
import SaveDataInformation from '../../../../share/modal/SaveDataInformation'
import clientObjectMixin from '../../../share/mixins/clientObjectMixin'

export default {
  components: {
    AttachmentRequirementType,
    SelectType,
    List,
    LoginModal,
    SaveDataInformation
  },
  mixins: [
    Page,
    ErrorNotify,
    clientObjectMixin
  ],
  data () {
    return {
      service: this.$route.params.service,
      events: null,
      headerTitle: { title: 'Wymagalność kategorii załączników: Generali', description: 'Tryb edycji' },
      model: {
        roleId: null,
        categoryRequirements: []
      },
      isSaved: true,
      saveDataInformationVisible: false,
      previouslySelectedRole: null,
      taskCategories: [],
      taskCategoriesLoaded: false,
      roles: [],
      rolesLoaded: false,
      states: [],
      statesLoaded: false,
      categories: [],
      categoriesLoaded: false,
      loginVisible: false,
      allowedAccess: false
    }
  },
  computed: {
    categoryGroup() { return  this.$getCategoryGroupNew(this.clientObject, this.$route.params.taskCategoryId) },
    categoryName () { return  this.$getCategoryNew(this.clientObject, this.$route.params.taskCategoryId).name },
    workflowId () {return  this.$getCategoryNew(this.clientObject, this.$route.params.taskCategoryId).workflows[0].id },
    categoryId() { return  this.$route.params.taskCategoryId },
  },
  created () {
    this.getInitEvents()
  },
  mounted () {
    this.$nextTick(() => {
      this.loginVisible = true
      this.$events.on(this.events.categoryRequirementsSubmit, this.submitData)
    })
  },
  methods: {
    getInitEvents () {
      this.events = {
        categoryRequirementsSubmit: `${this.service}:appraisal:attachmentCategoryRequirementSubmit`
      }
    },
    init () {
      this.allowedAccess = true
      this.loadTaskCategories()
      this.loadRoles()
      this.loadStates()
      this.loadCategories()
    },
    loadTaskCategories () {
      api.request(this.service, 'get', `/task-categories?group=appraisal`)
        .then((response) => {
          const taskCategories = response.data
          for (let c = 0; c < taskCategories.length; ++c) {
            this.taskCategories.push({ label: taskCategories[c].name, value: taskCategories[c].id })
          }
          this.taskCategoriesLoaded = true
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Wystąpił błąd',
            text: 'Nie można załadować typów zlecenia'
          })
        })
    },
    loadRoles () {
      api.request(this.service, 'get', '/roles')
        .then((response) => {
          const roles = response.data
          for (let c = 0; c < roles.length; ++c) {
            this.roles.push({ label: roles[c].label, value: roles[c].id })
          }
          this.rolesLoaded = true
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Wystąpił błąd',
            text: 'Nie można załadować ról'
          })
        })
    },
    loadStates () {
      api.request(this.service, 'get', `/workflows/${this.workflowId}/states`)
        .then((response) => {
          const states = response.data
          for (let c = 0; c < states.length; ++c) {
            this.states.push({ label: states[c].label, value: states[c].id })
          }
          this.statesLoaded = true
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Wystąpił błąd',
            text: 'Nie można załadować stanów'
          })
        })
    },
    loadCategories () {
      api.request(this.service, 'get', `/attachment-categories`)
        .then((response) => {
          const categories = response.data
          for (let c = 0; c < categories.length; ++c) {
            this.categories.push({ label: categories[c].name, value: categories[c].id })
          }
          this.categoriesLoaded = true
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Wystąpił błąd',
            text: 'Nie można załadować kategorii'
          })
        })
    },
    createField (fieldItem) {
      let fieldParams = {
        id: fieldItem.id,
        label: fieldItem.field.label
      }
      return fieldParams
    },
    forceToSave () {
      this.isSaved = false
    },
    changeRole (optionValue) {
      if (!this.isSaved && this.model.categoryRequirements.length > 0) {
        document.getElementById('role').value = this.previouslySelectedRole
        this.saveDataInformationVisible = true
        return
      }

      this.model.roleId = this.previouslySelectedRole = optionValue

      this.loadCategoryRequirements()
    },
    loadCategoryRequirements () {
      api.request(this.service, 'get', `/roles/${this.model.roleId}/attachment-category-requirements`)
        .then((response) => {
          this.model.categoryRequirements = response.data
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Wystąpił błąd',
            text: 'Nie można załadować widoczności pól'
          })
        })
    },
    createEmptyElement () {
      return {
        id: null,
        taskCategory: { id: null },
        state: { id: null },
        category: { id: null }
      }
    },
    submitData () {
      api.request(this.service, 'put', `/attachment-category-requirements`, this.createDataToSend())
        .then(() => {
          this.isSaved = true
          this.$notify({
            type: 'success',
            title: 'Sukces',
            text: 'Dane zapisane poprawnie'
          })
        })
        .catch((error) => {
          this.errorNotify(error)
        })
    },
    createDataToSend () {
      let submitData = { categoryRequirements: [], role: this.model.roleId }
      for (let c = 0; c < this.model.categoryRequirements.length; ++c) {
        submitData.categoryRequirements.push({
          id: this.model.categoryRequirements[c].id,
          taskCategory: this.model.categoryRequirements[c].taskCategory.id,
          role: this.model.roleId,
          state: this.model.categoryRequirements[c].state.id,
          category: this.model.categoryRequirements[c].category.id
        })
      }

      return submitData
    }
  }
}
</script>

<style scoped>
h2 {
    font-size: 18px
}
</style>
